import employeesReducer from "./reducers";
export { default as employeesTypes } from "./types";
export { default as employeesOperations } from "./operations";
export default employeesReducer;
